import React, { useEffect, useState } from 'react';
import { useLocalStorage } from 'react-use';
import { useRecoilState, useRecoilValue } from 'recoil';
import { AnimatePresence, motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-duotone-svg-icons';
import { userAtom, mainPageInitializeAtom, userPrivilagesAtom } from '../../../atoms/Atoms';
import AuthenticatedSideBar from '../menu-sidebar/shared-components/AuthenticatedSideBar';
import { Spinner } from '../Spinner';
import { backdropVariants } from '../../../utils';
import envConfig from '../../../envConfig';

function MainPage({ includeBack, requiresLogin, requiresGlobalAdmin, requiresAdmin, requiresCustomerService, requiresCloserAdmin, requiresCloser, requiresSetter, requiresManager, requiresLearningManager, requiresLearning, children }) {
  const { t } = useTranslation();
  const history = useHistory();
  const [impersonate] = useLocalStorage(`${envConfig.StoragePrefix}-impersonate`);
  const user = useRecoilValue(userAtom);
  const userPrivilages = useRecoilValue(userPrivilagesAtom);
  const [initializing, setInitializing] = useRecoilState(mainPageInitializeAtom);
  
  useEffect(() => {
    setTimeout(() => setInitializing(false), 250);
  }, []);

  useEffect(() => {
    if (!initializing) {
      const requiresRole = requiresGlobalAdmin || requiresAdmin || requiresCustomerService || requiresCloserAdmin || requiresCloser || requiresSetter || requiresManager || requiresLearningManager || requiresLearning;
      if (user?.forcePasswordReset && !impersonate) {
        window.location = '/updatepass';
      } else if ((requiresLogin || requiresRole) && !user) {
        window.location = '/';
      } else if (requiresRole) {
        let hasRequired = false;
        if (requiresSetter && (userPrivilages.hasCloserPrivilages || userPrivilages.hasSetter)) {
          hasRequired = true;
        } else if (requiresCloser && userPrivilages.hasCloserPrivilages) {
          hasRequired = true;
        } else if (requiresManager && userPrivilages.hasCloserManagerPrivilages) {
          hasRequired = true;
        } else if (requiresCloserAdmin && userPrivilages.hasCloserAdminPrivilages) {
          hasRequired = true;
        } else if (requiresCustomerService && userPrivilages.hasCustomerSupportPrivilages) {
          hasRequired = true;
        } else if (requiresAdmin && userPrivilages.hasAdminPrivilages) {
          hasRequired = true;
        } else if (requiresGlobalAdmin && userPrivilages.hasGlobalPrivilages) {
          hasRequired = true;
        } else if (requiresLearningManager && userPrivilages.hasLearningManager) {
          hasRequired = true;
        } else if (requiresLearning && userPrivilages.hasLearning) {
          hasRequired = true;
        }
        if (!hasRequired) {
          window.location = '/';
        }
      }
    }
  }, [initializing]);

  return (
    <AnimatePresence>
      <div className="max-w-screen-3xl mx-auto flex w-full h-full divide-x">
        {/* <div className="px-4 py-2 hidden md:inline-block w-auto h-full">
          <AuthenticatedSideBar />
        </div> */}
        <div className="w-full p-4 lg:px-24">
          {includeBack && (
          <button
            type="button"
            className="flex w-min cursor-pointer space-x-2"
            onClick={() => history.goBack()}
          >
            <FontAwesomeIcon className="text-xl" icon={faArrowLeft} />
            <strong className="text-lg -mt-1">{t('return')}</strong>
          </button>
          )}
          {children}
        </div>
      </div>
      {/* {initializing && (
        <motion.div
          variants={backdropVariants}
          initial="visible"
          animate="hidden"
          exit="visible"
          className="fixed bg-gray-800 inset-0 bg-opacity-75 z-20"
        >
          <div className="loading-screen loading-screen-full-white">
            <Spinner className="text-accentColor" big />
          </div>
        </motion.div>
      )} */}
      <motion.div
        variants={backdropVariants}
        initial="visible"
        animate="hidden"
        exit="visible"
        className={`${initializing ? 'fixed' : 'hidden'} bg-gray-800 inset-0 bg-opacity-75 z-20`}
      >
        <div className="loading-screen loading-screen-full-white">
          <Spinner className="text-accentColor" big />
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default MainPage;
